import { SlideOver } from "./SlideOver";
import { Sparkles } from "lucide-react";

export function ComingSoonPanel({ open, onClose, title }) {
  return (
    <SlideOver open={open} onClose={onClose} title={title} subtitle="Detailed configuration for this section is coming next." testid={`coming-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
      <div className="p-10 flex flex-col items-center text-center">
        <div className="h-16 w-16 rounded-2xl bg-gradient-to-br from-violet-100 to-sky-100 flex items-center justify-center mb-4">
          <Sparkles className="h-6 w-6 text-violet-600" />
        </div>
        <h3 className="text-lg font-semibold text-slate-900">Coming in the next sprint</h3>
        <p className="text-sm text-slate-500 max-w-md mt-2">
          The backend for <b>{title}</b> is already live. The dedicated editor UI ships in the next sprint —
          your data model is stable so nothing you build here will be lost.
        </p>
      </div>
    </SlideOver>
  );
}
